export default "__VITE_ASSET__3b0b483f__"